import React, { useState, useEffect, useLayoutEffect } from "react";
import { Container, Accordion, useAccordionButton } from "react-bootstrap";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Pharmeasy from "../../assets/dust/pharmeasy.webp"
import MultiImageUploader from "../../component/multi-image-uploader";
import tataOneMg from "../../assets/dust/tata-onemg.webp";
import { useDispatch, useSelector } from "react-redux";
import BreadcrumbWithUrl from "../../component/breadcrumb/breadcrumb-with-url";
import { APP_SUB_FOLDER, Domain, site_SEO_META } from "../../constants/app-constants";
import Helmet_SEO_META from "../../component/seo_meta";
import { useLocation } from "react-router";
import { getMetaData, orderMedicineNew } from "../../actions/cms-api-handlers";

import countries from "../../assets/data/countries.json";
import { useFormik } from "formik";
import { leadSquaredStatus } from "../../actions/post-call";
const OrderMedicineComponent = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const selectedUser = useSelector((state) => state.selectedUser.value);
	const [selectedCountry, setSelectedCountry] = useState('India');
	const [selectedState, setSelectedState] = useState('');
	const [selectedCity, setSelectedCity] = useState('');
	const [allState, setAllState] = useState('');
	const [allCity, setAllCity] = useState('');
	const [isTermAgreed, setIsTermAgreed] = useState(false);
	const [cKey, setCKey] = useState(["0"]);
    const  [deliveryAddressTab, setDeliveryAddressTab]=useState(true)
	const [uploadPrescriptionTab, setUploadPrescriptionTab]=useState(false)
    const [orderConfirmationTab, setOrderConfirmationTab]=useState(false)
	   
	const [prescription, setPrescription] = useState(null);
	const [isConsentSigned, setIsConsentSigned] = useState(false);
    const [confirmDetails, setConfirmDetails]=useState({name:'', mobileNo:'', email:'', address:''})
   const [orderId, setOrderId]=useState()

 
   useEffect(() => {  

	let getAllState  = countries.find(function (country) {
		return +country.c === 91;
		}); 
	setAllState(getAllState.s);

  },[]);

   function cityList(e) {
	setSelectedState(e.target.value);
	if (countries && allState && e.target.value) {
		let countryIndex = countries.map(e => e.n).indexOf(selectedCountry);
		let stateIndex = allState.map(e => e.n).indexOf(e.target.value);
		setAllCity(countries[countryIndex]['s'][stateIndex]['c']);
		let Ele = document.querySelector('#city').closest('div');
		Ele.classList.remove('notselected');

	}
}
  const onContinueHandler=()=>{	
	if(document.querySelector('#name').value == ''){
		return showError("Full name is mandatory!");
	}
	if(document.querySelector('#mobile').value == ''){	
		return showError("Mobile is mandatory!");
	}
	if(document.querySelector('#mobile').value?.length <= 9){		
		return showError("Please Enter a Valid Mobile No.");
	}
	if(document.querySelector('#email').value == ''  ){	
		return showError("Email is mandatory!");
	}

	if(document.querySelector('#AddressLine').value == ''){
		return showError("Address   is mandatory!");
	}

	if(document.querySelector('#state').value == ''){
		return showError("State is mandatory!");
	}
	if(document.querySelector('#city').value == ''){
		return showError("Cityis mandatory!");
	}
	if(document.querySelector('#pincode').value == ''){
		return showError("Pincode is mandatory!");
	}
	setCKey(["0","1"])
	setUploadPrescriptionTab(true)
  }



  const formik = useFormik({
	initialValues: {
		mobile: "",
		email: "",
		addressOne: "",
		name: "",
		pincode:''
	},

	onSubmit: (values, helpers) => {
       
		if (values.name === "") {
			return showError("Full name is mandatory!");
		} else if (values.mobile === "") {
			return showError("Mobile is mandatory!");
		} else if (values.email === "") {
			return showError("Email is mandatory!");
		} 
		else if (values.addressOne === "") {
			return showError("Address Line 1 is mandatory!");
			
		} 
		else if (values.pincode === "") {
			return showError("Pincode is mandatory!");
			
		}
		else if (!isConsentSigned) {
			return;
		} else if (!isTermAgreed) {
			return showError("Please check terms & conditions!");
		} else if (!prescription) {
			return showError("Please upload prescriptions!");
		}
		

		const formData = new FormData();
		
		formData.append('name', values.name);
		formData.append('mobile_number', values.mobile);
		formData.append('email', values.email);
		formData.append('location', values.addressOne);		
		formData.append('city', document.querySelector('#city').value);
		formData.append('state', selectedState);
		formData.append('pincode', values.pincode);
		formData.append('patient_id', selectedUser? selectedUser.id:'');
		formData.append('patient_name', selectedUser? selectedUser.full_name:'');

		if (prescription) {			
			for (const key in prescription) {			
			    // formData.append('prescription', prescription[key].data_url); // Base 64
				//formData.append('prescription', prescription[key].file); // files	
				formData.append('prescription[]', prescription[key].file);
			}

		}
 
		 orderMedicineNew(formData)
			.then(function (response) {
				let res = response.data;
				console.log("response", response)			
				if (response.statusText === "OK" || response.status === 200) {
					setOrderConfirmationTab(true)					
					setCKey(["0","1","2"])
					showToast( res.message)
					setOrderId(res.data.order_id)
					setConfirmDetails({name:values.name, mobileNo:values.mobile, email:values.email, address:values.addressOne})
					
					let prescriptionURL = response.data.data.s3_url.toString();
					// console.log(prescriptionURL)
					//response.data.data.s3_url
					 leasSqurApiHandler(values.name, values.mobile, values.addressOne, document.querySelector('#city').value, prescriptionURL)
				}				
			     if (response.statusText === "Bad Request" || response.status === 400) {
					res.errors.map((error) => {
						return showError(error.message);
					})
			}
			// if (response.status === 413) {
			// 	return showToast('file size must not be greater than to 5MB');
			// }

				// setOrderDetail(res);
			}).catch(function (err) { });
	}
});

function showError(str) {
	toast.error(str, {
		position: "top-right",
		autoClose: 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: false,
		draggable: false
	});
}
function showToast(str) {
	toast.success(str, {
	  position: "top-right",
	  autoClose: 3000,
	  hideProgressBar: false,
	  closeOnClick: true,
	  pauseOnHover: false,
	  draggable: false
	});
  }

const leasSqurApiHandler=(fname, mobile, address, city, prescription)=>{
	var data = [
		{ "Attribute": "FirstName", "Value": fname },
        { "Attribute": "Mobile", "Value": mobile },
		{ "Attribute": "mx_Patient_Address", "Value": address },
        { "Attribute": "mx_City", "Value": city },
		{ "Attribute": "mx_Prescription_Link", "Value": prescription},
        { "Attribute": "SourceCampaign", "Value": 'Order Medicine Web' }
	];

	// for (const key in prescription) {	
	// 	data.push({ "Attribute": "mx_Prescription_Link", "Value": prescription[key]})
	// }



	leadSquaredStatus(data).then(function (response) {	
        })
        .catch(function (err) {
        });
}


	const breadCrumbData = [
		{ type: 1, url: `${APP_SUB_FOLDER}/`, name: 'Home' },
		{ type: 3, name: 'Order Medicine' },
	];
	// seo meta tag
	const [getSeoMata, setGetSeoMata]=useState("")
	const pageURL = window.location.origin + window.location.pathname;
	const [SEO_META, setSEO_META]=useState({
		title: "Order Medicine Online | Buy Medicine with Affordable Price | MyHealthcare",
		description: "Order Medicines Online from Top Pharmacies for Skin, Hair, Heart, and all Personal Daily Health. Baby, Men, Women, and Elderly care Products Online only at MyHealthcare. On-time Medicine Delivery at the Best Price",
		keywords: "Online Medicine Order,Buy Medicines Online with the affordable price,Order Medicines Online,Buy medicines online at low prices, Same Day Fastest Medicine Home delivery",
	  pageURL: pageURL
	})
	useEffect(() => {
	  const url =    Domain + location.pathname;
	  getMetaData(url).then(function (response) {
		setGetSeoMata(response.data) 
	})
	.catch(function (err) {
	});  
	}, []);
	useEffect(() => {   
	  if(getSeoMata && getSeoMata?.status == true){
			  setSEO_META({
				title: getSeoMata.data[0].title,
				description: getSeoMata.data[0].description,
				keywords: getSeoMata.data[0].keyword,
				pageURL: pageURL
			})
	  }
	}, [getSeoMata])
	return (
		<React.Fragment>
			<Helmet_SEO_META SEO_META={SEO_META} />
			<form onSubmit={formik.handleSubmit}>
				<Container>
					<BreadcrumbWithUrl breadcrumbs={breadCrumbData} />
					<h5 className="fs-7 text-secondary">Order Medicine</h5>
         
			       {/* accordion starts */}
				   <div className="accordion_orderMed">                    
                      
					
						<Accordion   activeKey={cKey} alwaysOpen className="mt-3 mhc-profile-tabs">
							<Accordion.Item eventKey="0" > 
								<Accordion.Header  className={` ${deliveryAddressTab===false ? "medicineTab":''} mb-3`}>Delivery Address</Accordion.Header>
							
									{
										deliveryAddressTab ?		<Accordion.Body className="py-3">	<div className="row">
										<div className="col-md-4">
										<div className="form-floating mb-4">
															<input
																type="text"
																className="form-control"
																autoComplete="off"
																placeholder="Enter full name"
																name="name"
																id="name"
																onChange={formik.handleChange}
																value={formik.values.name}
																//required
																
															/>
															<label htmlFor="name">Full Name <sup>*</sup></label>
														</div>
										</div>
										<div className="col-md-4">
										<div className="form-floating mb-4">
															<input
																type="text"
																className="form-control"
																name="mobile"
																autoComplete="off"
																placeholder="mobile"
																maxLength="10"
																id="mobile"
																//required
																onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
																onChange={formik.handleChange}
																value={formik.values.mobile}
															/>
															<label htmlFor="mobile">Mobile <sup>*</sup>
															</label>
														</div>
										</div>
										<div className="col-md-4">
										<div className="form-floating mb-4">
															<input
																type="text"
																className="form-control"
																name="email"
																autoComplete="off"
																id="email"
																placeholder="Enter email"
																onChange={formik.handleChange}
																value={formik.values.email}
																//required
															/>
															<label>Email <sup>*</sup></label>
														</div>
										</div>
										<div className="col-lg-12">
										<div className="form-floating mb-4">
															<input
																type="text"
																className="form-control"
																name="addressOne"
																autoComplete="off"
																placeholder="AddressLine"
																id="AddressLine"
																onChange={formik.handleChange}
																value={formik.values.addressOne}
																//required
															/>
															<label>Address Line 1 <sup>*</sup></label>
														</div>
										               </div>
								
                    <div className="col-md-4 ">
                    <div className={`mhc-selectbox ${selectedState==""? "notselected":"" }  mb-4`}>
					<select
									name="state"
									//required
									id="state"
									className="form-select"
									onChange={(e) => { cityList(e) }}
									value={selectedState}>
								    <option value=""></option>
									{
										
										allState && allState.map((item) => {
											const { n } = item;
											return (<option key={n} value={n}>{n}</option>);
										})
									}
								</select>
								<label htmlFor="floatingSelect">State*</label>
                    </div>
                    </div>
                    <div className="col-md-4 ">
                    <div className={`mhc-selectbox ${selectedCity==""? "notselected":"" }  mb-4`}>
					<select
									name="city"
									//required
									id="city"
									className="form-select"
									onChange={(e) => { setSelectedCity(e.target.value) }}
									value={selectedCity}>
							
									{
										allCity && allCity.map((item) => {
											return (<option key={item} value={item}>{item}</option>);
										})
									}
								</select>
								<label htmlFor="floatingSelect">City*</label>
                    </div>
                    </div>
					<div className="col-md-4">
					<div className="form-floating position-relative mb-4">
								<input
									type="text"
									className="form-control"
									//required
									maxLength="6"							
									value={formik.values.pincode}
									autoComplete="off"
									placeholder="Enter pincode"
									id="pincode"
									onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }}
									onChange={formik.handleChange}
								/>
							

								<label>Pincode <sup>*</sup></label>
							</div>
						
                     
                    </div>
									
										<div className="col-lg-6">
											<div className="form-check">
												<input className="form-check-input" type="checkbox"  id="flexCheckDefault"
													required
													value={isTermAgreed}
													
											        onClick={(e) => setIsTermAgreed(e.target.checked)}
												/>
												<label className="form-check-label  d-block d-sm-inline" htmlFor="flexCheckDefault">
												I have read and agree to the <a  href={`${APP_SUB_FOLDER}/terms-and-conditions`}  target="_blank"  className="text-primary text-decoration-none">Terms and Conditions.</a>
												</label>
											</div>
											{/* <div className="form-check mt-3">
													<input className="form-check-input" type="checkbox" autocomplete="off" defaultValue="" id="flexCheckDefault2"  />
													<label className="form-check-label  d-block d-sm-inline" htmlFor="flexCheckDefault2">
													Save For Future Deliveries
													</label>
												</div> */}
										</div>
								          <div className="col-lg-6 mt-3 mt-lg-0">
											<div className="d-flex align-items-center justify-content-start justify-content-lg-end"> 
											<div><label className="fs-7">Our Partners: </label></div>
											<div className="ms-3"><img src={tataOneMg} className="lab-icon" /></div>
											<div className="ms-3"></div><img src={Pharmeasy} className="lab-icon" />									
											
											</div>
										  </div>
									  
										
											<div className="col-12 mt-3 text-center">
												<button onClick={()=>onContinueHandler()} disabled={  isTermAgreed === true ? false :true} className="btn btn-outline-primary rounded-1 " type="button" >Continue</button>
											</div>
									   
									   
									</div>	</Accordion.Body>:""
									}
							
							
							</Accordion.Item>
				
		
						
							<Accordion.Item eventKey="1">
								<Accordion.Header  className="mb-3">Upload Prescription</Accordion.Header>
								{
									uploadPrescriptionTab === true  ?	<Accordion.Body className="py-3 px-1">
									<div className="row">
										
										
										<div className= " col-md-6 mhc-multiImage">
											<div className="mb-3">
											<MultiImageUploader setPrescri={setPrescription} />
											</div>
										   
											<div>
											<h6>Patient Consent</h6>
												<p>By Confirming the order i consent to my prescription being shared with MyHealthcare Pharmacy patners for home delivery of medicines</p>

											</div>                   
											<div className="form-check">
											<input
																		className="form-check-input"
																		type="checkbox"
																		value={isConsentSigned}
																		disabled={!prescription}
																		onChange={(e) => setIsConsentSigned(e.target.checked)} />
												<label className="form-check-label " htmlFor="flexCheckDefault3">
													I Agree
												</label>
											</div>
											<div className="mt-3">
												<button className="btn btn-primary rounded-1 "  disabled={  isConsentSigned === true ? false :true} type="submit" >Confirm Order</button>
											</div>
										</div>           
														
										
										
										<div className="col-md-6 mt-4 mt-md-0 ">
											<div className="bg-white mhc-payment-details div_ul_name">
											<div className="details_prescription">
												   <h6>Prescription should contain</h6>
												   <ul className="ul_name">
													   <li className="li_name">Government regulation requires a prescription for ordering some medicines</li>
													   <li className="li_name">Order will be processed only after receiving the prescription</li>
													   <li className="li_name">Don't crop out any part of the image</li>
													   <li className="li_name">Include doctor & patient name as well as clinic/hospital visit date</li>
													   <li className="li_name">Medicines will be dispensed as per availability</li>
													   <li className="li_name">Supported files type: jpeg , jpg , png, pdf</li>
												   </ul>
												   </div>       
											</div>
										</div>
									</div>
								</Accordion.Body>:""
								}
							
							</Accordion.Item>
							<Accordion.Item eventKey="2">
								<Accordion.Header  className="mb-3">Order Confirmation</Accordion.Header>
								{
									orderConfirmationTab  ?	<Accordion.Body className="py-3 px-1 ">
									<div className="row">
										<div className="col-md-12">
											<h1 className="fs-5 text-primary">Order Confirmed</h1>
											<p className="mhc-dector-profile-text">Thank you, <strong>{confirmDetails.name}</strong> for entrusting your health in our hands. Your Order Details are below.</p>
										</div>
										</div>									
										{
												selectedUser !=null ?
													<p className="mhc-dector-profile-text mt-4"><span className="patient-width">Ordered By: </span>
													
													
													{selectedUser?.full_name}</p>:''
												
												
											}
										<div className="mhc-patient-details mt-2 p-0">
											<div className="row justify-content-center">
												
												<div className="col-lg-5 text-start text-lg-start ">
													<div className="mhc-details-border p-3">
													<p className="mhc-dector-profile-text d-flex"><span className="patient-width mb-1">Patient Name</span> <span className="dot">:</span> {confirmDetails.name}</p>
													<p className="mhc-dector-profile-text d-flex"><span className="patient-width mb-1">Mobile No</span> <span className="dot">:</span> {confirmDetails.mobileNo}</p>
													<p className="mhc-dector-profile-text d-flex"><span className="patient-width mb-1">Email ID</span> <span className="dot">:</span> {confirmDetails.email}</p>
													<p className="mhc-dector-profile-text d-flex"><span className="patient-width">Delivery Address</span> <span className="dot">:</span> {confirmDetails.address}</p>
													
											
													</div>

												</div>
												
												<div className="col-lg-7 align-self-center">
													<div className="p-3">
													<p className="text-center"> Your Order ID: <strong>{orderId}</strong>  has been submitted successfully. <br className="d-none d-md-block" />

Our Patient Services Team will reach out to you shortly.</p>
													{/* <p className="m-0">Our pharmacy patner PharmEasy will call you back to process your order</p> */}
												
														</div>
													
												</div>
												
											</div>
											
										</div>
										
								</Accordion.Body>:''
								}
							
							</Accordion.Item>
						</Accordion>
					</div>
					
					
			   

				</Container>
			</form>

			<ToastContainer />
		</React.Fragment>
	);
};

export default OrderMedicineComponent;
